import { createUIDefinition } from '../default-task-definition'
import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'


export default createUIDefinition({
    taskName: taskName.TREATMENT_QUOTATION_CREATED_WHATS_APP,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.WHATS_APP_TEXT_WIDGET_CONTAINER,
            widgetProps: {
                textId: 'treatmentQuotationCreated',
            },
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
        },
        {
            component: processUI.SENT_EMAIL_WIDGET,
        },
        {
            component: processUI.TREATMENT_QUOTATION_WIDGET,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
        {
            component: processUI.TECHNICAL_LOG_CONTAINER,
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_QUOTATION,
            taskPath: ['objectDetail'],
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/treatment-quotation-created-whats-app.js